module.exports = __webpack_public_path__ + "img/r9.bb399db3.jpg";